import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

function FindUs() {
  const businessAddress = "ART Aesthetics & Skincare, Hughes Close, Widnes, WA8 5EJ";
  // Google Maps embed URL for Hughes Close, Widnes
  const googleMapsEmbedUrl = "https://www.google.com/maps?q=Hughes+Close,+Widnes+WA8+5EJ&output=embed";

  return (
    <div className="find-us-page">
      <SEO
        title="Find ART Aesthetics & Skincare in Widnes"
        description="Visit ART Aesthetics & Skincare at Hughes Close, Widnes. Serving Widnes and nearby towns for skincare and confidence-led treatments."
        path="/find-us"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Place',
          name: 'ART Aesthetics & Skincare',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Hughes Close',
            addressLocality: 'Widnes',
            postalCode: 'WA8 5EJ',
            addressCountry: 'GB'
          },
          hasMap: 'https://maps.app.goo.gl/oLykmTW4paVJ7i4W9',
          url: 'https://artaestheticsskincare.com/find-us'
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="page-header"
      >
        <h1>Find Us</h1>
        <p>Visit us at our convenient location</p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="find-us-content"
      >
        <div className="location-info">
          <div className="info-card">
            <h2>📍 Our Location</h2>
            <p className="address">{businessAddress}</p>
          </div>

          <div className="info-card">
            <h2>💬 Get in Touch</h2>
            <p>Follow us on Instagram: <a href="https://www.instagram.com/art_aesthetics_skin" target="_blank" rel="noopener noreferrer">@ART_Aesthetics_Skin</a></p>
            <a 
              href="https://www.instagram.com/art_aesthetics_skin" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cta-button primary"
              style={{ display: 'inline-block', marginTop: '1rem' }}
            >
              DM Us on Instagram
            </a>
          </div>

          <div className="info-card">
            <h2>🚗 Parking</h2>
            <p>Free parking available nearby</p>
          </div>
        </div>

        <div className="map-container">
          <iframe
            title="ART Aesthetics & Skincare Location"
            src={googleMapsEmbedUrl}
            width="100%"
            height="450"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <div className="map-link">
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(businessAddress)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Open in Google Maps
            </a>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default FindUs;
